import { SmartLink } from "@selector/shared/components";
import { type FC } from "react";

import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";

const HspRankCell: FC<IAgGridCellProps> = (props) => {
  const { value, data } = props;
  if (!data) {
    return null;
  }

  const hitRank = data.blastHit.rank;
  const hspRank = data.rank;

  const getData = (): { tooltip: string; target: string } => {
    return {
      tooltip: `Go to alignment of HSP ${hspRank} of hit ${hitRank}`,
      target: `/job/${data.jobId}/results/${data.queryId}/alignments/${hitRank}/${hspRank}`,
    };
  };

  const { tooltip, target } = getData();

  return (
    <TableCell>
      <SmartLink to={target} tooltip={tooltip} forceTooltip>
        {value}
      </SmartLink>
    </TableCell>
  );
};

export default HspRankCell;
